import MaterialsApi from './src/Material'
import MaterialWareHouseApi from './src/MaterialWarehouse'
import MaterialResourcerecordApi from './src/MaterialResourcerecord'
import RescourseTeamApi from './src/ResourcesTeam'
import AddressbookApi from './src/Addressbook'
import EmergencyEventApi from './src/EmergencyEvent'
import EmergencyEventReportApi from './src/EmergencyEventReport'
import PersonOrganiztionApi from './src/PersonOrganiztion'
import PlanApi from './src/Plan'
import TranResourcesApi from './src/Tranresources'
import ShelterApi from './src/Shelter'
import CommunicationresourcesApi from './src/Communicationresources'
import MedicalresourcesApi from './src/Medicalresources'
import PlanAttachApi from './src/PlanAttach'
import PlanTaskApi from './src/Plantask'
import PlantaskreceiverApi from './src/Plantaskreceiver'
import PlantasksettingApi from './src/Plantasksetting'


//执行记录api
import ExecutRecordApi from './src/ExecutRecord'
import ExecutTaskApi  from './src/ExecutTask'
import ExecutFeedbackApi from './src/ExecutFeedback'
import FeedAttachApi from './src/FeedAttach'

import ExecutSummaryApi from './src/ExecutSummary'


//设备记录api 
import EquipmentApi from './src/Equipment'
import DocumentApi from './src/Document'

let apis = {
    MaterialsApi,
    MaterialWareHouseApi,
    MaterialResourcerecordApi,
    RescourseTeamApi,
    AddressbookApi,
    EmergencyEventApi,
    EmergencyEventReportApi,
    PersonOrganiztionApi,
    PlanApi,
    TranResourcesApi,
    ShelterApi,
    CommunicationresourcesApi,
    MedicalresourcesApi,
    PlanAttachApi,
    PlanTaskApi,
    PlantaskreceiverApi,
    PlantasksettingApi,

    ExecutRecordApi,
    ExecutTaskApi,
    ExecutFeedbackApi,
    FeedAttachApi,

    ExecutSummaryApi,

    EquipmentApi,
    DocumentApi
};

export default apis;
